/**
 * Zip entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Zip extends BaseModel {
    defaults() {
        return {
            id: null,
            type: null,
            zip: null,
            extra_nr: null,
            city_short: null,
            city_long: null,
            canton: null,
            country_code: null,

            // view fields
            region_ids: null,
            regions: null,
            country_id: null,
        };
    }

    mutations() {
        return {
            id: Number,
            type: Number,
            zip: Number,
            extra_nr: Number,
        };
    }

    get zipString() {
        return String(this.zip);
    }

    options() {
        return {
            identifier: 'id',
        };
    }

    entityName() {
        return 'Zip';
    }
}

export class ZipCollection extends BaseCollection {
    options() {
        return {
            model: Zip,
        };
    }

    entityName() {
        return 'Zip';
    }
}
